export default __webpack_public_path__ + "static/lozenge-anatomy-dark-3962e479b9c9d7e4dc80c18a6fa90a0d36439603a95966621b559223698737b5.png";